import React from 'react'
import ToggleButton from './toggle-button'
import ToggleSelect from './toggle-select'
import ToggleCancel from './toggle-cancel'

const GovActionsToggle = ({
  options = [],
  toggle,
  onChange,
  value,
  icon,
  open,
  label,
  formSuccess = false,
}) => {
  if (options.length === 0) return null

  if (open)
    return (
      <ToggleCancel toggle={toggle} icon={icon}>
        {formSuccess ? 'Close' : 'Cancel'}
      </ToggleCancel>
    )
  if (options.length === 1) return <ToggleButton icon={icon} label={label} toggle={toggle} />

  return (
    <ToggleSelect icon={icon} label={label} onChange={onChange} value={value} options={options} />
  )
}

export default GovActionsToggle



// WEBPACK FOOTER //
// ./src/ui/gov-actions/views/toggle.jsx